var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#37AEE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0708 25.1038L18.2549 33.5766C18.2549 33.5766 18.6529 34.3681 19.0782 34.3681C19.5035 34.3681 25.8443 28.0272 25.8443 28.0272L32.8947 14.9343L15.1822 22.9151L15.0708 25.1038Z",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2945 27.2772L18.6827 33.5219C18.6827 33.5219 18.428 35.4351 20.4158 33.5219C22.4035 31.6087 24.3117 30.1328 24.3117 30.1328",
    fill: "#A9C6D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1297 25.4063L8.5796 23.3553C8.5796 23.3553 7.79723 23.0492 8.04968 22.3583C8.10199 22.2161 8.20661 22.0937 8.51819 21.8838C9.96922 20.9108 35.378 12.1319 35.378 12.1319C35.378 12.1319 36.0967 11.9001 36.5198 12.0532C36.7131 12.1232 36.8382 12.2041 36.9405 12.4949C36.9792 12.5998 36.9996 12.8272 36.9974 13.0502C36.9951 13.212 36.9746 13.3607 36.9587 13.5969C36.8041 15.9977 32.1735 33.914 32.1735 33.914C32.1735 33.914 31.896 34.9614 30.9044 34.9985C30.5428 35.0116 30.1039 34.9417 29.5785 34.5066C27.6294 32.8951 20.8974 28.5439 19.41 27.5884C19.3258 27.5337 19.3031 27.4638 19.2872 27.396C19.2667 27.2954 19.3804 27.1708 19.3804 27.1708C19.3804 27.1708 31.1046 17.1522 31.4162 16.1004C31.4412 16.0195 31.3502 15.978 31.2274 16.013C30.4496 16.2885 16.9491 24.4836 15.4595 25.3888C15.373 25.4412 15.1297 25.4063 15.1297 25.4063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2c71e43a0efcb8afa78290202e9a93bb.svg";
export { ForwardRef as ReactComponent };